import type {ValidityIssueType} from 'nutshell-graphql-types';

// Generic host name which can be swapped with host's actual username
export const GENERIC_HOST_NAME = 'This host';

// The types of meeting issues
export const MEETING_VALIDITY_ISSUES: Partial<
    Record<
        ValidityIssueType,
        {
            text: string;
            description: string;
            name: string;
        }
    >
> = {
    USER_REMOVED: {
        text: 'No longer a Nutshell user',
        description:
            // This host is no longer a Nutshell user and cannot co-host this meeting
            `${GENERIC_HOST_NAME} is no longer a Nutshell user and cannot co-host this meeting`,
        name: 'User removed',
    },
    CALENDAR_DISCONNECTED: {
        text: 'Calendar not connected',
        description:
            // This host needs to log in to Nutshell and re-enable their calendar
            `${GENERIC_HOST_NAME} needs to log in to Nutshell and repair their calendar connection`,
        name: 'Calendar',
    },
    O365_GOOGLE_MEET: {
        text: 'Google Meet requires a Google Calendar sync',
        description:
            // This host can't be synced through Office 365 for a Google Meet meeting
            `${GENERIC_HOST_NAME} can't be synced through Office 365 for a Google Meet meeting`,
        name: 'Google Meet',
    },
    ZOOM_NOT_ENABLED: {
        text: 'Zoom not connected',
        description:
            // This host needs to log in to Nutshell and reconnect their Zoom account
            `${GENERIC_HOST_NAME} needs to log in to Nutshell and reconnect their Zoom account`,
        name: 'Zoom',
    },
    TEAMS_NOT_ENABLED: {
        text: 'Teams not connected',
        description:
            // This host needs to log in to Nutshell and reconnect their Teams account
            `${GENERIC_HOST_NAME} needs to log in to Nutshell and reconnect their Teams account`,
        name: 'Teams',
    },
};
